<template>
    <FinalField
        :name="name"
        :validate="validate"
    >
        <template v-slot="props">
            <div class="form-field">
                <label class="radio-label flex">
                    <input
                        v-model="props.value"
                        type="radio"
                        class="radio"
                        :name="props.name"
                        :checked="props.value === value"
                        :value="value"
                        :data-test="name"
                        :disabled="disabled"
                        @blur="props.events.blur()"
                        @focus="props.events.focus()"
                        @change="props.change(props.value)"
                    />
                    {{ label }}
                </label>

                <FieldError :name="name" />
            </div>
        </template>
    </FinalField>
</template>

<script>
import { FinalField } from 'vue-final-form';
import FieldError from '@/components/form/FieldError';

export default {
    components: {
        FinalField,
        FieldError,
    },

    props: {
        name: {
            type: String,
            required: true,
        },

        label: {
            type: String,
        },

        validate: {
            type: [Function, Array],
            required: false,
        },

        value: {
            type: String,
        },

        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
